

export function BridgerDiffuse(props, selectedStandard) {
    // console.log("Diffuse", props)
    const { data, laserOperation } = props.result
    const result = data
    const inputs = props.data?.diffuseReflectiveCW ?? props.data?.diffuseReflectiveSP ?? props.data?.diffuseReflectiveRP


    const getAE = (AE, unit) => {
        if (AE.includes("J") || AE.includes("W")) {
            return AE
        }
        else if (unit === "W") {
            return AE + "W/m²"
        }
        else if (unit === "J") {
            return AE + "J/m²"
        }
    }
    const MPE = result?.MPE?.mpeStandard?.pretty || result?.MPEsingle?.mpeStandard?.pretty || result?.MPE?.single?.mpeStandard?.pretty || result?.ExtendedMPE?.mpeStandard?.pretty
    // console.log("diffuse", result)
    const x = {
        laserOperation: props.data.laserOperation.toLowerCase(),
        sourceType: 'Diffuse Reflective',
        standard: selectedStandard,
        wavelength: `${inputs.wavelength.num} ${inputs.wavelength.unit !== false ? inputs.wavelength.unit : " "}m`,
       ...(inputs.time) ? {
            time: `${inputs?.time?.num}${inputs.time.unit && inputs?.time?.unit !== false ? inputs?.time?.unit : " "}s`,
        } : {},
        ...(inputs.duration) ?
        {
            pulseDuration: `${inputs?.duration?.num} ${inputs?.duration?.unit !== false ? inputs?.duration?.unit : " "}s`
        }
        :
        {
            pulseDuration: `${inputs?.pulseDuration?.num} ${inputs?.pulseDuration?.unit !== false ? inputs?.pulseDuration?.unit : " "}s`
        },

        ...(inputs.power ? {
            power: `${inputs.power.num} ${inputs.power.unit !== false ? inputs.power.unit : " "}W`
        } 
        : inputs.peakPower ? {
            peakPower: `${inputs.peakPower.num} ${inputs.peakPower.unit !== false ? inputs.peakPower.unit : " "}W`
        }
        : inputs.averagePower ? {
            averagePower: `${inputs.averagePower.num} ${inputs.averagePower.unit !== false ? inputs.averagePower.unit : " "}W`
        } : {
            energy: `${inputs.energy.num} ${inputs.energy.unit !== false ? inputs.energy.unit : " "}J`
        }),
        ...(inputs?.pulseFrequency ? {
            pulseFrequency: `${inputs?.pulseFrequency?.num} ${inputs?.pulseFrequency?.unit !== false ? inputs?.pulseFrequency?.unit : " "}Hz`
        }: {}),
        beamDiameter: `${inputs?.beamDiameter?.num} ${inputs?.beamDiameter?.unit !== false && inputs?.beamDiameter?.unit ? inputs?.beamDiameter?.unit : " "}m`,
        beamDivergence: `${inputs?.beamDivergence?.num} ${inputs?.beamDivergence?.unit !== false ? inputs?.beamDivergence?.unit : " "}m`,
        distance: `${inputs.distance.num} ${inputs.distance.unit !== false ? inputs.distance.unit : " "}m`,
        distance2: props.data?.diffuseReflective?.distance2 ? `${props.data.diffuseReflective?.distance2.num} ${props.data?.diffuseReflective?.distance2?.unit !== false ? props.data?.diffuseReflective?.distance2?.unit : " "}m` : null,
        albedo: props.data.diffuseReflective.albedo ? `${props.data?.diffuseReflective?.albedo?.num} %` : null,
        spot_size: result.outputBeamDiameter,
        eye_LA: (result?.limitAperture?.eye || result.limitingAperture.eye) + 'mm',
        skin_LA: (result?.limitAperture?.skin || result.limitingAperture.skin) + 'mm',
        applicable_eye: result?.beamArea?.applicablePretty || result.applicableBeamArea?.applicableBeamAreaEyePrettiest,
        applicable_skin: result?.skinApplicableArea?.skinApplicableAreaPrettiest || result.applicableBeamArea?.applicableBeamAreaSkinPrettiest,
        timebase: result?.laserClass?.condition1?.timeBase,


        mpe: {
            eye: {
                ...(laserOperation.includes('epetitivelyPulsed')
                    ? {
                        mpe: {
                            single: {
                                mpe: result?.MPE?.single?.mpeStandard?.pretty,
                                excess: result?.MPEExcess?.joulesPerSqmPretty || result.safetyratio.joulesPretty.pretty,
                                ae_applicable: result?.MPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            },
                            pulse_train: {
                                mpe: result?.MPE?.pulseTrain?.mpeStandard?.pretty,
                                excess: result?.MPEExcess?.joulesPerSqm_trainPretty || result.safetyratio.averagePretty.pretty,
                                ae_applicable: result?.MPE?.pulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.pulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            },
                            average: {
                                mpe: result?.MPE?.average?.mpeStandard?.pretty,
                                excess: result?.MPEExcess?.joulesPerSqm_averagePretty || result.safetyratio.pulseTrainPretty.pretty,
                                ae_applicable: result?.MPE?.average?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.MPE?.average?.mpeStandard?.unit?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                            }
                        },
                        ae_applicable: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.MPEExcess?.joulesPerSqmPretty || result?.safetyratio?.joulesPretty?.pretty,
                        mostRestrictive: getMostRestrictiveKey("eye", result),
                    }
                    : {
                        mpe: MPE || 1,
                        ae_applicable: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.AE?.joulesPerSqmPretty ?? result?.AE?.joulesPerSqmPretty, "J") : getAE(result?.AE?.wattsPerSqmPretty ?? result?.AE?.wattsPerSqmPretty, "W"),

                        // ae_actual: MPE?.includes("J") ? getAE(result?.AE?.actual_joulesPerSqmPretty ?? result?.AE?.actual_joulesPerSqmPretty, "J") : getAE(result?.AE?.actual_wattsPerSqmPretty ?? result?.AE?.actual_wattsPerSqmPretty, "W"),
                        excess: result?.MPEExcess?.joulesPerSqmPretty || result?.MPEexcess?.joulesPerSqmPretty || result?.safetyRatio?.pretty?.pretty || result?.safetyratio?.pretty?.pretty

                    }
                )
            },
            skin: {
                ...(laserOperation.includes('epetitivelyPulsed')
                    ? {
                        mpe: {
                            single: {
                                mpe: result?.skinMPE?.single?.mpeStandard?.pretty ?? result?.MPEskin?.mpeStandard?.pretty,
                                excess: result?.skinMPEExcess.joulesPretty_single.pretty,
                                ae_applicable: result?.skinMPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.single?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                            },
                            pulse_train: {
                                mpe: result?.skinMPE?.PulseTrain?.mpeStandard?.pretty,
                                excess: result?.skinMPEExcess.joulesPretty_train.pretty,
                                ae_applicable: result?.skinMPE?.PulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.PulseTrain?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                            },
                            average: {
                                mpe: result?.skinMPE?.MPEAverage?.mpeStandard?.pretty,
                                excess: result?.skinMPEExcess.joulesPretty_average.pretty,
                                ae_applicable: result?.skinMPE?.MPEAverage?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                                ae_actual: result?.skinMPE?.MPEAverage?.mpeStandard?.unit?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                            }
                        },
                        ae_applicable: MPE?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        ae_actual: MPE?.includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        excess: result?.skinMPEExcess.joulesPretty.pretty,
                        mostRestrictive: getMostRestrictiveKey("skin", result),
                    }
                    : {
                        mpe: result?.skinMPE?.mpeStandard?.pretty ?? result?.MPEskin?.mpeStandard?.pretty,
                        ae_applicable: (result?.skinMPE?.mpeStandard?.unit ?? result?.MPEskin?.mpeStandard?.unit).includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty?.eng ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty?.eng ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        ae_actual: (result?.skinMPE?.mpeStandard?.unit ?? result?.MPEskin?.mpeStandard?.unit).includes("J") ? getAE(result?.skinAE?.joulesPerSqmPretty ?? result?.skinAE?.joulesPerSqmPretty, "J") : getAE(result?.skinAE?.wattsPerSqmPretty ?? result?.skinAE?.wattsPerSqmPretty, "W"),
                        excess: result?.skinMPEExcess?.joulesPretty?.pretty || result?.skinMPEExcess?.joulesPerSqmPretty
                    }
                )
            }
        },

        nohd: result?.NOHD?.value?.pretty || 'N/A',
        enohd: result?.ENOHD?.value?.pretty || 'N/A',

        ael: {
            condition1: {
                classes: [
                    {
                        name: 'Class 1',
                        ael: result.laserClass.condition1.class.class1?.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition1.class.class1?.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition1.class.class1.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition1?.class?.class1?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition1.class.class1.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.class.class1, result.laserClass.condition1.details.collectedEmission.joules),
                        },

                    },
                    {
                        name: 'Class 2',
                        ael: result.laserClass.condition1.class.class2?.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition1.class.class2?.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition1?.class?.class2?.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition1?.class?.class2?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition1?.class?.class2?.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.class.class2, result.laserClass.condition1.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Class 3R',
                        ael: result.laserClass.condition1.class.class3r?.aelStandard?.pretty || 'N/A', 
                        excess: result.laserClass.condition1.class.class3r?.excess?.pretty || 'N/A', 
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition1.class.class3r?.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition1.class.class3r?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition1.class.class3r?.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.class.class3r, result.laserClass.condition1.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Class 3B',
                        ael: result.laserClass.condition1.class.class3b?.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition1.class.class3b?.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition1.class.class3b?.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition1.class.class3b?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition1.class.class3b?.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition1.class.class3b, result.laserClass.condition1.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Collected Emission',
                        ael: `${result.laserClass.condition1.details.collectedEmission.joulesPretty} | ${result.laserClass.condition1.details.collectedEmission.joules}`
                    }
                ],
                misc: [
                    {
                        name: 'Aperture Stop',
                        value: result.laserClass.condition1.details.aperture
                    },
                    {
                        name: 'Aperture Distance',
                        value: result.laserClass.condition1.details.distance
                    },
                    {
                        name: 'Angular Subtense',
                        value: result.laserClass.condition1.details.angularSubtense || 'N/A'
                    },
                    {
                        name: 'Acceptance Angle',
                        value: result.laserClass.condition1.acceptanceAngle || 'N/A'
                    }
                ]
            },
            condition3: {
                classes: [
                    {
                        name: 'Class 1',
                        ael: result.laserClass.condition3.class.class1?.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition3.class.class1?.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition3.class.class1?.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.class.class1?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition3.class.class1?.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.class.class1, result.laserClass.condition3.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Class 2',
                        ael: result.laserClass.condition3.class.class2.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition3.class.class2.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition3?.class?.class2?.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass?.condition3?.class?.class2?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass?.condition3?.class?.class2?.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.class.class2, result.laserClass.condition3.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Class 3R',
                        ael: result.laserClass.condition3.class.class3r.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition3.class.class3r.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition3.class.class3r?.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.class.class3r?.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition3.class.class3r?.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.class.class3r, result.laserClass.condition3.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Class 3B',
                        ael: result.laserClass.condition3.class.class3b.aelStandard?.pretty || 'N/A',
                        excess: result.laserClass.condition3.class.class3b.excess?.pretty || 'N/A',
                        pf: 'Fail',
                        mostRestrictive: false,
                        ...(laserOperation.includes('Repetitively')) && {
                            ael_spTrain: result.laserClass.condition3.class.class3b.pulseTrain?.joulesPretty || 'N/A',
                            ael_SPT: result.laserClass.condition3.class.class3b.AELSPT?.joulesPretty || 'N/A',
                            ael_T: result.laserClass.condition3.class.class3b.average?.joulesPretty || 'N/A',
                            mostRestrictive: getMostRestrictiveAEL(result.laserClass.condition3.class.class3b, result.laserClass.condition3.details.collectedEmission.joules),
                        }
                    },
                    {
                        name: 'Collected Emission',
                        ael: `${result.laserClass.condition3.details.collectedEmission.joulesPretty} | ${result.laserClass.condition3.details.collectedEmission.wattsPretty}`
                    }
                ],
                misc: [
                    {
                        name: 'Aperture Stop',
                        value: result.laserClass.condition3.details.aperture
                    },
                    {
                        name: 'Aperture Distance',
                        value: result.laserClass.condition3.details.distance
                    },
                    {
                        name: 'Angular Subtense',
                        value: result.laserClass.condition3.details.angularSubtense || 'N/A'
                    },
                    {
                        name: 'Acceptance Angle',
                        value: result.laserClass.condition3.acceptanceAngle || 'N/A'
                    }
                ]
            }
        },

        eyewear: [
            {
                config: 'Results at 200m',
                nominal_od: result.NominalOD.OD,
                rb_number: result.RBNumber,
                lb_glass: result.Glass,
                lb_plastic: result.Plastic,
                lb_glass_average: result.Glass_average,
                lb_plastic_average: result.Plastic_average,

            },
            {
                config: 'Results at 0.1m',
                nominal_od: result.NominalOD_distance.OD,
                rb_number: result.RBNumber_distance,
                lb_glass: result.Glass_Distance,
                lb_plastic: result.Plastic_Distance,
                lb_glass_average: result.GlassAverage_Distance,
                lb_plastic_average: result.PlasticAverage_Distance
                ,
            }
        ],

        verdict: result.laserClass.Class,
        correctionFactors: result.correctionFactors,
        spectrum: result.spectrum
    }

    return x
}

function getMostRestrictiveKey(type, result) {
    const source =
        type === 'eye'
            ? result?.MPE
            : result?.skinMPE;

    if (!source) return null;

    const values = {
        single: source?.single?.mpeStandard?.num,
        pulse_train: source?.pulseTrain?.mpeStandard?.num || source?.PulseTrain?.mpeStandard?.num,
        average: source?.average?.mpeStandard?.num || source?.MPEAverage?.mpeStandard?.num
    };

    // Filter out undefined/null before finding min
    const filtered = Object.entries(values).filter(([_, v]) => v != null);

    if (filtered.length === 0) return null;

    const minVal = Math.min(...filtered.map(([_, v]) => v));

    // Return the key with the smallest value
    const mostRestrictive = filtered.find(([_, v]) => v === minVal)?.[0];
    return mostRestrictive || null;
}

function getMostRestrictiveAEL({ aelStandard, pulseTrain, AELSPT, }, collectedEmission) {
    const values = {
        ael: aelStandard?.num,
        ael_spTrain: pulseTrain?.joules,
        ael_SPT: AELSPT?.joules,

    };

    // console.log(collectedEmission, "collectedEmission")

    // Filter out invalid (NaN) values
    const filtered = Object.entries(values).filter(([_, v]) => !isNaN(v));

    if (filtered.length === 0) return null;

    // Find smallest value
    const minVal = Math.min(...filtered.map(([_, v]) => v));

    // Get the key that matched the min
    const mostRestrictive = filtered.find(([_, v]) => v === minVal);

    // console.log("most rest", collectedEmission < mostRestrictive[1], collectedEmission, mostRestrictive[1])

    const status = collectedEmission <= mostRestrictive[1] ? 'Pass' : 'Fail'

    return mostRestrictive
        ? { key: mostRestrictive[0], value: mostRestrictive[1], status: status }
        : null;
}